{
  "achievements": "成就",
  "advanced": "高级",
  "all": "全部",
  "antiFakeProtection": "反欺诈保护",
  "antiFakeProtectionText": "所有领取请求均在服务器端验证，以防止欺诈活动。",
  "approvedClaims": "已批准领取",
  "approvedExalt": "已批准 EXALT",
  "beginner": "初级",
  "claim5Exalt": "领取 5 EXALT",
  "claimDailyMining": "领取每日挖矿奖励",
  "claimDailyRewardDesc": "领取您的每日 5 EXALT 奖励。",
  "claimDailyRewardDescription": "每天领取 5 EXALT。",
  "claimFailed": "领取失败。",
  "claimedToday": "今日已领取",
  "completed": "已完成",
  "completedTasks": "已完成任务",
  "cooldown": "冷却时间",
  "correctAnswerRewardAdded": "回答正确！奖励已发放。",
  "cryptoBasics": "加密货币基础",
  "dailyMiningRate": "每日挖矿速率",
  "dailyReward": "每日奖励",
  "dailyRewardClaimed": "每日奖励已领取。",
  "dailyStreak": "连续签到天数",
  "days": "天",
  "distributed": "已发放",
  "downloadCertificate": "下载证书",
  "duration": "时长",
  "exaltExchangeUser": "Exalt 交易所用户",
  "exaltMiningPool": "EXALT 矿池",
  "failedLoadRewards": "奖励加载失败。",
  "firstLesson": "第一课",
  "intermediate": "中级",
  "learnEarn": "学习赚币",
  "learnEarnSubtitle": "观看课程，完成测验，赚取 EXALT 奖励。",
  "learnEarnTitle": "学习赚币",
  "learnerAchievement": "学习者成就",
  "learningLevel": "学习等级",
  "learningProgress": "学习进度",
  "lessonCompleted": "课程已成功完成。",
  "level": "等级",
  "loadingLessons": "课程加载中...",
  "locked": "已锁定",
  "masterAchievement": "大师成就",
  "miningProtectionNote": "挖矿奖励已受到防自动化及重复领取保护。",
  "miningRewardSubmitted": "挖矿奖励领取申请已提交。",
  "myRewardClaims": "我的奖励领取记录",
  "noAchievements": "暂无成就。",
  "noActivityYet": "暂无动态。",
  "noMinersYet": "暂无矿工。",
  "noReferrersYet": "暂无推荐人。",
  "noRewardClaimsYet": "暂无奖励领取记录。",
  "oneClaimEvery24Hours": "每24小时可领取一次。",
  "optionAfterPayment": "确认付款之后",
  "optionAnyTime": "任何时候",
  "optionBeforePayment": "付款之前",
  "optionDeleteTokens": "删除代币",
  "optionLockTokens": "锁定代币以获取奖励",
  "optionPrivateKey": "分享私钥",
  "optionProtectWallet": "保护钱包密钥",
  "optionSendTokens": "转出代币",
  "optionUnknownLinks": "使用未知链接",
  "p2pSafety": "P2P 安全指南",
  "pendingValue": "待处理价值",
  "questionCrypto": "在加密货币领域最安全的规则是什么？",
  "questionP2p": "在 P2P 交易中应何时放行加密货币？",
  "questionStaking": "质押是什么意思？",
  "quiz": "测验",
  "recentActivity": "最近动态",
  "referralRewardNote": "推荐奖励将在管理员审核后发放。",
  "referralRewardPool": "推荐奖励池",
  "referrals": "推荐",
  "reward": "奖励",
  "rewardClaim": "奖励领取",
  "rewardClaimFailed": "奖励领取失败。",
  "rewardClaimed": "奖励领取成功。",
  "rewardCompleted": "奖励已完成。",
  "rewardFailed": "奖励领取失败。",
  "searchLessons": "搜索课程...",
  "securityReview": "安全审核",
  "serverError": "服务器错误。",
  "sessionExpired": "会话已过期，请重新登录。",
  "stakingGuide": "质押指南",
  "startLesson": "开始学习",
  "submitQuizClaimReward": "提交测验并领取奖励",
  "submitting": "提交中...",
  "todayClaims": "今日领取",
  "topLearners": "学习排行榜",
  "topMiners": "顶尖矿工",
  "topReferrers": "顶尖推荐人",
  "totalClaims": "领取总数",
  "totalPool": "奖池总额",
  "totalRewards": "总奖励",
  "used": "已使用",
  "videoCryptoBasics": "什么是加密货币，交易所如何运作？",
  "videoP2pSafety": "如何与 P2P 用户安全交易",
  "videoStakingGuide": "质押奖励如何运作",
  "viewAgain": "再次查看",
  "wrongAnswerTryAgain": "回答错误，请重试。",
  "xpPoints": "经验值",
  "you": "你"
}